export default {
    name: 'seats',

    computed: {
        cinema_id() {
            return this.$route.params.cinema_id
        },

        session_id() {
            return this.$route.params.session_id
        }
    },

    created () {
        // console.log(this.cinema_id, this.session_id);
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/seats/seats.js